import { Observable } from 'rxjs';
import { PhConfigLoaderModel } from './ph-config-loader.model';

export class PhConfigLoaderFactoryModel extends PhConfigLoaderModel {
  cb?: (config: PhConfigLoaderModel) => Observable<PhConfigLoaderModel>;
}
